import React, { FC } from 'react';
import { Button } from '@domain-group/fe-co-button';
import { SwaggerContextState } from './swaggerContext';
import * as styles from './authoriser.styles';

interface AuthorisedProps {
  swaggerContext: SwaggerContextState;
}

const Authorised: FC<AuthorisedProps> = ({ swaggerContext }) => (
  // allow reset the authorisation of swagger token
  <div css={styles.container}>
    <p>
      Authentication Success. Use the &quot;Try It Out&quot; button(s) below.
    </p>
    <p>
      Authenticated using: {swaggerContext.credentialId} (
      {swaggerContext.credentialType === 'oAuthClient'
        ? swaggerContext.credentialFlow
        : swaggerContext.credentialType}
      )
    </p>
    <p>
      <Button
        appearance="ghostPrimary"
        size="small"
        onClick={() => swaggerContext.reset()}
      >
        Reset
      </Button>
    </p>
  </div>
);
export default Authorised;
